import { useState } from 'react';
import { faqItems } from '@/mocks/categories';
import SchemaOrg from '@/components/base/SchemaOrg';

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <>
      <SchemaOrg data={faqPageSchema} />
      <section className="py-14 md:py-20 bg-background-100">
        <div className="px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-4 py-1.5 border border-primary-300 text-primary-700 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
                FAQ
              </span>
              <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
                Frequently Asked Questions
              </h2>
              <p className="mt-3 text-foreground-600 text-sm md:text-base">
                Everything you need to know about the Vigorbuy Spreadsheet and how to use it effectively.
              </p>
            </div>

            <div className="space-y-3">
              {faqItems.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-lg overflow-hidden transition-all duration-200"
                >
                  <button
                    onClick={() => toggle(idx)}
                    className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer group"
                    aria-expanded={openIndex === idx}
                  >
                    <span className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4 group-hover:text-primary-700 transition-colors duration-200">
                      {item.question}
                    </span>
                    <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ${
                      openIndex === idx
                        ? 'bg-primary-500 text-background-50 rotate-45'
                        : 'bg-background-100 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-600'
                    }`}>
                      <i className="ri-add-line text-lg"></i>
                    </span>
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}